import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"

const firebaseConfig = {
  apiKey: "AIzaSyA0xNY0uYH-uVeg6zEavEkDPKfk8l2pSyg",
  authDomain: "nkp-foundation.firebaseapp.com",
  projectId: "nkp-foundation",
  storageBucket: "nkp-foundation.appspot.com",
  messagingSenderId: "528026177333",
  appId: "1:528026177333:web:7981342a21c4e89f0c867c",
  measurementId: "G-SSH0NL0H67",
}

const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
